module.exports = __webpack_public_path__ + "static/media/sound-tech.ac3bb5d3.jpg";